import React, { useEffect,useState } from 'react';
import Button from '../button';

import './styles.scss';

function MessageDialog({ message,
    onConfirm, onCancel, isShow }) {
    
    const handleClick = () => {
        //onConfirm();
        if (onCancel) {
            onCancel(false);
        }
    };

    return (
        <div className="messagedialog" style={{ display: message ? 'flex' : 'none' }}>
            <div className="messagedialogModel">
                <div className="dialogTitle">提示</div>
                <div className="dialog-content">
                    <div className="dialogContent">{message}</div>
                    <Button btnclass="close_btn " onClick={() => handleClick()}
                        title="关&nbsp;&nbsp;闭"  />                       
                    </div>
                    </div>           
        </div>
    );
};

export default MessageDialog;